const styles = () => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    minHeight: 400,
  },
  listItem: {
    width: 132,
    height: 132,
  },
  rootEmpty: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    minHeight: 400,
  },
})

export default styles
